import React from 'react';
import { Button } from 'antd';
import { SwapOutlined } from '@ant-design/icons';

/**
 * Mensagem do modal de exclusão de projeto: avisa que as integrações do projeto
 * e os relatórios delas também serão excluídos, listando as integrações.
 * Com `onChangeProject`, cada integração ganha um atalho para trocá-la de projeto.
 */
const ProjectDeleteMessage = ({ project, syncs, onChangeProject, loadingSyncId }) => {
  if (!project) return 'Tem certeza que deseja excluir este projeto?';

  const syncList = Array.isArray(syncs) ? syncs : Array.isArray(project.syncs) ? project.syncs : [];

  return (
    <>
      Tem certeza que deseja excluir o projeto <strong>"{project.name}"</strong>? Esta ação não pode ser desfeita.
      {syncList.length > 0 && (
        <>
          <br /><br />
          Ao excluir o projeto, <strong>todas as sincronizações abaixo e os relatórios dessas sincronizações também serão excluídos</strong>:
          <ul style={{ margin: '8px 0', paddingLeft: 20 }}>
            {syncList.map((sync) => (
              <li key={sync.id}>
                {sync.name}
                {onChangeProject && (
                  <Button
                    type="link"
                    size="small"
                    icon={<SwapOutlined />}
                    loading={loadingSyncId === sync.id}
                    onClick={() => onChangeProject(sync)}
                  >
                    Trocar projeto
                  </Button>
                )}
              </li>
            ))}
          </ul>
          Se desejar manter alguma integração, troque-a de projeto pelas configurações da integração antes de excluir este projeto.
        </>
      )}
    </>
  );
};

export default ProjectDeleteMessage;
